import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const lifetimeOffer = 'lifetime_offer';

export enum Parameter {
  Cross = 'cross',
  Timer = 'timer',
  Continue = 'continue',
}

export const useLifetimeOfferPopupAnalytics = () => {
  const trackLifetimeOfferPopupShow = useCallback(() => {
    TrackingApi.trackPopup({
      info: lifetimeOffer,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackLifetimeOfferPopupClose = useCallback((parameter: string) => {
    TrackingApi.trackPopup({
      info: lifetimeOffer,
      operation: 'close',
      parameter,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackLifetimeOfferPopupClick = useCallback(() => {
    TrackingApi.trackPopup({
      info: lifetimeOffer,
      operation: 'click',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackLifetimeOfferPopupShow,
    trackLifetimeOfferPopupClose,
    trackLifetimeOfferPopupClick,
  };
};
